import React, {useState} from 'react';
import glamorous from 'glamorous';
import {FOCUS_BLUE, CHARCOAL, WHITE} from '../../../shared/style/colors';
import {FONTS, WEIGHT} from '../../../shared/style/typography';
import {LAPTOP, PHONE} from '../../../shared/style/breakpoints';
import {ALPHA} from '../../../shared/style/color-utils';
import GhostButton from '../../../shared/library/buttons/base/ghost';
import RequestDemo from './request-demo';
import StackShareEnterpriseForm from '../../../shared/library/stackshare-enterprise-form';

const Container = glamorous.div({
  backgroundColor: CHARCOAL,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  width: '100%',
  padding: '0 20px'
});

const Title = glamorous.h3({
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontWeight: WEIGHT.ULTRA_BLACK,
  fontSize: 40,
  lineHeight: '50px',
  color: WHITE,
  marginTop: 93,
  marginBottom: 32,
  [LAPTOP]: {
    textAlign: 'center'
  },
  [PHONE]: {
    fontSize: 24,
    margin: '62px 0 0',
    textAlign: 'center'
  }
});

export const CtaContainer = glamorous.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 93,
  [PHONE]: {
    width: '85%',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});

export const SignUpButton = glamorous(GhostButton)(
  {
    borderRadius: 4,
    height: 58,
    fontSize: 20,
    backgroundColor: FOCUS_BLUE,
    color: WHITE,
    fontWeight: WEIGHT.ULTRA_BOLD,
    textAlign: 'center',
    padding: '0 41px',
    fontFamily: FONTS.CEREBRI_SANS_PRO,
    marginRight: 66,
    ':hover': {
      background: ALPHA(FOCUS_BLUE, 0.8),
      color: WHITE
    },
    [PHONE]: {
      fontSize: 20,
      fontWeight: WEIGHT.ULTRA_BOLD,
      margin: '23px 0 0',
      padding: 0,
      width: '100%'
    }
  },
  ({extraStyle}) => (extraStyle ? extraStyle : {})
).withComponent('a');

const GetStarted = () => {
  const [isLeadFormOpen, setLeadFormOpen] = useState(false);

  return (
    <Container>
      <Title>Get started with StackShare Enterprise for Free</Title>
      <CtaContainer>
        <SignUpButton
          href="mailto:private@stackshare.io"
          title="Contact Us"
          target="_blank"
          color={FOCUS_BLUE}
        >
          Contact Us
        </SignUpButton>
        <RequestDemo
          eventProperties={{
            index: 1,
            sectionName: 'GetStarted'
          }}
          extraStyle={{
            color: WHITE,
            background: CHARCOAL,
            fontFamily: FONTS.CEREBRI_SANS_PRO,
            fontSize: 20,
            fontWeight: WEIGHT.ULTRA_BOLD,
            height: 58,
            padding: '0 41px',
            border: `1px solid ${WHITE}`,
            borderRadius: 4,
            minWidth: 'auto',
            [PHONE]: {
              fontSize: 20,
              fontWeight: WEIGHT.ULTRA_BOLD,
              margin: '23px 0 0',
              width: '100%'
            },
            '&:hover': {
              background: ALPHA(WHITE, 0.1),
              border: `1px solid ${WHITE}`
            },
            '&:focus': {
              border: `1px solid ${FOCUS_BLUE}`
            }
          }}
        />
      </CtaContainer>
      {isLeadFormOpen && (
        <StackShareEnterpriseForm
          onDismiss={() => setLeadFormOpen(false)}
          title="Have questions before you sign up?"
          type="lead"
        />
      )}
    </Container>
  );
};

export default GetStarted;
